import $ from 'jquery'
import { ready } from 'shared/ready'
import Faq from '../components/faq'

class ATSChecker {
  constructor($el) {
    if ($el.length === 0) return

    new Faq({
      root: $el.find('.home__faq'),
      classes: {
        seen: 'home__faq--seen',
        question: 'home__question',
        opened: 'home__question--opened',
        content: 'home__question-content',
      },
    })

    this.postCount = $el.find('.ats-checker-resume-rater-step').length
    this.currentPost = 1

    this.nextPost()
    this.interval = setInterval(this.nextPost.bind(this), 5000)

    $('.ats-checker-resume-rater-step').each((index, el) => {
      $(el).on('click', () => {
        this.setPost(index + 1)
      })
    })

    $('.nav__bar').css('background', '#F7F9FC')
  }

  nextPost() {
    this.currentPost = (this.currentPost || 0) + 1
    if (this.currentPost > this.postCount) {
      this.currentPost = 1
    }
    this.updateView()
  }

  setPost(index) {
    this.currentPost = index
    this.updateView()

    clearInterval(this.interval)
    this.interval = setInterval(this.nextPost.bind(this), 5000)
  }

  updateView() {
    const allSteps = $('.ats-checker-resume-rater-step')
    const allImages = $('.ats-checker-resume-rater-right-img')

    allSteps.each((index, step) => {
      step.classList.toggle('active', index === this.currentPost - 1)
    })

    allImages.each((index, img) => {
      img.style.display = index === this.currentPost - 1 ? 'block' : 'none'
    })
  }
}

// ---
// Init
// ---
ready(function () {
  return new ATSChecker($('.ats-checker-root'))
})
